import {
  REQUEST_MAP_ORIGENAL_POSITIONS,
  RESPONSE_MAP_ORIGENAL_POSITIONS,
  REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE,
  CLEAR_MAP_ORIGENAL_POSITIONS,
} from "../actions/mapOrigenalPositionsAction";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  origenalPositions: [],
};

const mapOrigenalPositionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_ORIGENAL_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_MAP_ORIGENAL_POSITIONS:
      const { positons } = action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        origenalPositions: positons,
        errors: [],
      });
    case REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_ORIGENAL_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapOrigenalPositionsReducer;
